import { render, staticRenderFns } from "./VerificationBadges.vue?vue&type=template&id=57214c43"
import script from "./VerificationBadges.vue?vue&type=script&lang=js"
export * from "./VerificationBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports